import baseOption from '@/options/mixins/base-option';

export default {
    mixins: [baseOption],

    data() {
        return {
            slider: true,
            sliderIndex: 0,
            state: '',
        };
    },

    computed: {
        sliderValue() {
            return this.themeObjectValues[this.sliderIndex];
        },
    },

    methods: {
        onInput(index) {
            this.sliderIndex = index;
            this.removeClasses();

            const flexClassNew = this.addFlexClass({
                value: this.themeObjectValues[index],
                side: this.side,
                state: this.state,
            });

            this.onOptionChange(flexClassNew);
        },

        onSideInput(sideNew) {
            this.side = sideNew;
            this.setSlider();
        },

        onStateInput(stateNew) {
            this.state = stateNew;
            this.setSlider();
        },

        async onUnitInput(unitNew) {
            let flexClassNew;

            this.unit = unitNew;

            switch (unitNew) {
                case 'rem':
                    this.slider = true;
                    this.setSlider();
                    this.removeFlexClass();
                    break;

                case '%': {
                    const defaultToZeroOptions = [
                        'border-radius',
                        'margin',
                        'min-height',
                        'min-width',
                        'padding',
                    ];

                    this.slider = true;
                    this.removeFlexClass();

                    if (defaultToZeroOptions.includes(this.optionName)) {
                        this.setSlider();
                    } else {
                        await this.setSliderMax();

                        flexClassNew = this.addFlexClass({
                            value: this.themeObjectValues[this.sliderIndex],
                        });
                    }

                    break;
                }

                case 'vw':
                    this.slider = false;
                    this.sliderIndex = 0;
                    this.removeFlexClass();

                    flexClassNew = this.addFlexClass({
                        value: '100vw',
                    });

                    break;

                case 'vh':
                    this.slider = false;
                    this.sliderIndex = 0;
                    this.removeFlexClass();

                    flexClassNew = this.addFlexClass({
                        value: '100vh',
                    });

                    break;

                case 'min-content':
                    this.slider = false;
                    this.sliderIndex = 0;
                    this.removeFlexClass();

                    flexClassNew = this.addFlexClass({
                        value: 'min-content',
                    });

                    break;

                case 'max-content':
                    this.slider = false;
                    this.sliderIndex = 0;
                    this.removeFlexClass();

                    flexClassNew = this.addFlexClass({
                        value: 'max-content',
                    });

                    break;

                // auto
                default:
                    this.sliderIndex = 0;
                    this.slider = false;
                    this.removeFlexClass();

                    if (this.optionName === 'width' || this.optionName === 'height') {
                        flexClassNew = this.addFlexClass({
                            value: 'auto',
                        });
                    }
            }

            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.setSide();
            this.setState();
            this.setUnit();
            this.setSlider();
        },

        async setSlider(optionsNew = null) {
            // using $nextTick gives the slider a chance to receive a new set of values
            // otherwise setting the index prematurely may cause the slider to throw an error
            await this.$nextTick();

            const optionsDefault = { useComputed: false };
            const options = { ...optionsDefault, ...optionsNew };

            const isSliderValue = this.themeObjectKeys.includes(this.flexClassDefinition.key);
            const hasAutoOption = this.tailwindDefinition.units.includes('auto');

            if (!this.flexClass && this.unit === 'auto' && hasAutoOption) {
                this.slider = false;
                return;
            }

            if (this.unit === 'vw' || this.unit === 'vh') {
                this.slider = false;
                return;
            }

            if (this.flexClassDefinition.state !== this.state) {
                this.sliderIndex = this.defaultIndex || 0;
                return;
            }

            if (this.flexClass && isSliderValue && !options.useComputed) {
                if (this.flexClassDefinition.key === 'auto') {
                    this.slider = false;
                    return;
                }

                this.slider = true;
                this.sliderIndex = this.getIndexByClass(this.flexClass);
            } else {
                this.slider = true;
                this.sliderIndex = this.getIndexByComputedProperty();
            }
        },

        async setSliderMax() {
            // using $nextTick gives the slider a chance to receive a new set of values
            // otherwise setting the index prematurely will cause the slider to throw an error
            await this.$nextTick();
            this.sliderIndex = this.themeObjectValues.length - 1;
        },
    },
};
